import store from '../store/index'
//----------------------
// get desc detail cols
//----------------------
export default function getDescDetailCols({
  headings,
  filter_status,
  view_round = 0,
  cur_round = 0,
}) {
  // console.log("-----------------------");
  // console.log("IN getDescDetailCols");
  let colNumbers = []
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let maxCA = this_store.config.max_ca
  let maxCR = this_store.config.max_cr
  //------------------------
  // set field cols to show
  //------------------------
  let fields = [
    'image',
    'name',
    'player_name',
    'sub_status_image',
    'visibility_image',
    'fatigue_image',
    'surprise_image',
    'bleeding_image',
    'options_image',
    'markers_image',
    'fill4',
    'category',
    'type',
    'race_name',
    'role',
    'dex',
    'ca',
    'cr',
    'damage_mod',
    'fill4',
    'sr',
    'sr_adj',
    'sr_roll',
    'roll_off',
    'rank',
    // 'fill1',
    'fill2',
    'fill3',
  ]

  if (cur_round > 1 && view_round == cur_round) {
    const fill1Index = fields.indexOf('fill2')

    fields.splice(
      fill1Index,
      0,
      'fill_last_action_before',
      'prev_round_action_image',
      'fill_last_action_after',
    )
  } else {
    fields.push('fill1')
  }
  //---------------------------------
  // load ca cols names where active
  //---------------------------------
  if (filter_status) {
    fields.push('seq')

    for (let i = 1; i <= maxCA; i++) {
      let ca = 'ca' + i
      fields.push(ca)
    }
    //---------------------------------
    // load cr cols names where active
    //---------------------------------
    for (let j = 1; j <= maxCR; j++) {
      let cr = 'cr' + j
      fields.push(cr)
    }
  }
  //--------------------------------
  // get headings idx for col names
  //--------------------------------
  for (let k = 0; k < fields.length; k++) {
    let idx = headings.findIndex((a) => a.field == fields[k])
    colNumbers.push(idx)
  }
  return colNumbers
}
